import React from 'react'
import tw from 'tailwind-styled-components'
import {bgMixin} from '@components/main-menu/mixins'

interface Props {
  children: React.ReactNode
  $active?: boolean
  onClick?: () => void
  className?: string
}

export const TwMenuButtonBase = tw.div<{$active?: boolean}>`
  text-panel-text-primary

  flex
  justify-start
  items-center

  ${p => (p.$active ? 'cursor-default' : 'cursor-pointer')}
`

const TwMenuButtonContainer = tw(TwMenuButtonBase)`
  h-[34px]
  min-h-32
  max-h-32
  pl-12
  ${p => bgMixin(p.$active)}
`

export const MenuButtonContainer = (props: Props) => {
  const {children, ...rest} = props

  return <TwMenuButtonContainer {...rest}>{children}</TwMenuButtonContainer>
}
